import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { MarketdateBooth } from './marketdate-booth.model';
import { MarketdateBoothPopupService } from './marketdate-booth-popup.service';
import { MarketdateBoothService } from './marketdate-booth.service';
import { Salesunit, SalesunitService } from '../salesunit';
import { Contact, ContactService } from '../contact';
import { Contract, ContractService } from '../contract';
import { Marketdate, MarketdateService } from '../marketdate';
import { User, UserService } from '../../shared';

@Component({
    selector: 'jhi-marketdate-booth-dialog',
    templateUrl: './marketdate-booth-dialog.component.html'
})
export class MarketdateBoothDialogComponent implements OnInit {

    marketdateBooth: MarketdateBooth;
    authorities: any[];
    isSaving: boolean;

    salesunits: Salesunit[];

    contacts: Contact[];

    contracts: Contract[];

    marketdates: Marketdate[];

    users: User[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private marketdateBoothService: MarketdateBoothService,
        private salesunitService: SalesunitService,
        private contactService: ContactService,
        private contractService: ContractService,
        private marketdateService: MarketdateService,
        private userService: UserService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['marketdateBooth', 'contractType', 'energyPriceType', 'marketdateBoothStatus']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.salesunitService.query().subscribe(
            (res: Response) => { this.salesunits = res.json(); }, (res: Response) => this.onError(res.json()));
        this.contactService.query().subscribe(
            (res: Response) => { this.contacts = res.json(); }, (res: Response) => this.onError(res.json()));
        this.contractService.query().subscribe(
            (res: Response) => { this.contracts = res.json(); }, (res: Response) => this.onError(res.json()));
        this.marketdateService.query().subscribe(
            (res: Response) => { this.marketdates = res.json(); }, (res: Response) => this.onError(res.json()));
        this.userService.query().subscribe(
            (res: Response) => { this.users = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.marketdateBooth.id !== undefined) {
            this.marketdateBoothService.update(this.marketdateBooth)
                .subscribe((res: MarketdateBooth) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        } else {
            this.marketdateBoothService.create(this.marketdateBooth)
                .subscribe((res: MarketdateBooth) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: MarketdateBooth) {
        this.eventManager.broadcast({ name: 'marketdateBoothListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    trackSalesunitById(index: number, item: Salesunit) {
        return item.id;
    }

    trackContactById(index: number, item: Contact) {
        return item.id;
    }

    trackContractById(index: number, item: Contract) {
        return item.id;
    }

    trackMarketdateById(index: number, item: Marketdate) {
        return item.id;
    }

    trackUserById(index: number, item: User) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-marketdate-booth-popup',
    template: ''
})
export class MarketdateBoothPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private marketdateBoothPopupService: MarketdateBoothPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.marketdateBoothPopupService
                    .open(MarketdateBoothDialogComponent, params['id']);
            } else {
                this.modalRef = this.marketdateBoothPopupService
                    .open(MarketdateBoothDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-booth/marketdate-booth-dialog.component.ts